import { wsLogger } from '@/shared/lib/logger';
import { cacheInvalidation } from '@/shared/lib/cache-invalidation';
import type { DataChangedEvent } from '../realtime-sync.types';
import { getAppRouter } from '@/shared/lib/app-router';

/**
 * Handle project deleted — clear localStorage, invalidate caches, redirect if viewing deleted project.
 */
export async function handleProjectDeleted(event: DataChangedEvent): Promise<void> {
  if (!event.id) return;

  wsLogger.info('[RealtimeSync] Project deleted:', { projectId: event.id });

  cacheInvalidation.afterDeleteProject(event.id);

  // Redirect to dashboard if currently viewing the deleted project
  if (window.location.pathname.startsWith(`/project/${event.id}`)) {
    getAppRouter()?.replace('/');
  }
}
